module.exports = __webpack_public_path__ + "img/builder-26.f64e4876.webp";